<div class="row mt-4 mb-4">
  <div *ngFor="let data of mappedData" class="col-6 col-md-4 col-lg-3 mb-2">
    <div class="card product-card">
      <div class="card-body text-center">
        <div class="image-wrapper" routerLink="/product/{{ data.product.id }}">
          <img
            class="img-fluid"
            src="https://cdn1.gung.io/fit-in/250x250/filters:fill(white):background_color(white):etag({{
              data.product.extra.images[0].s3ETag
            }}):format(jpeg)/{{ data.product.extra.images[0].s3Uri }}"
            alt=""
          />
        </div>
        <div class="product-text">
          <lib-availability *ngIf="isCapstone && includeAvailability" [availability]="data.availability">
          </lib-availability>
          <div class="text-truncate" translate>{{ data.product.name }}</div>
          <small translate
            >Art no: <span translate>{{ data.product.id }}</span></small
          >

          <div translate *ngIf="data.price">
            <span *ngIf="data.price.customerDiscountPercent === 0" class="mr-1" translate>NET_PRICE</span>
            <lib-price
              *ngIf="data.price.customerDiscountPercent === 0; else netPrice"
              [price]="data.price"
              type="NET"
            ></lib-price>
            <ng-template #netPrice>
              <lib-price
                [price]="data.price"
                type="GROSS"
              ></lib-price>
            </ng-template>
            <span *ngIf="data.price.customerDiscountPercent !== 0" class="ml-1">(-{{ data.price.customerDiscountPercent }}%)</span>
          </div>

          <small class="x-small d-block" *ngIf="!isCapstone">
            <span translate>VOLUME</span>
            <span>: {{ data.product.extra.ar.artbeskrspec }}</span>
          </small>

          <small class="x-small d-block">
            <span translate>PACKAGE_SIZE</span>
            <span>: {{ data.product.extra.ar.artfsgforp }}</span>
          </small>
        </div>

        <div *ngIf="isCapstone; else otherProject">
          <lib-buy-btn [id]="data.product.id"> </lib-buy-btn>
        </div>

        <ng-template #otherProject>
          <lib-buy-btn [id]="data.product.id" [stepAmount]="data.product.extra.ar.artfsgforp"></lib-buy-btn>
        </ng-template>
      </div>
    </div>
  </div>
</div>
